import React from 'react'

const NonAuthLayout = (props: any) => {

    return (
        <React.Fragment> {props.children}</React.Fragment>
    )
}

export default NonAuthLayout